<div class="ui-stepper" *ngIf="resolvedSteps.length > 0">
  <div class="ui-stepper__main-steps-wrap">
    <div
      class="ui-stepper__main-steps"
      [style.grid-template-columns]="columnsTemplate"
    >
      <app-stepper-main-step
        *ngFor="
          let step of resolvedSteps;
          let stepIndex = index;
          trackBy: trackByStep
        "
        [step]="step"
        [index]="stepIndex"
        [showConnector]="stepIndex < resolvedSteps.length - 1"
        [connectorActive]="isConnectorActive(stepIndex)"
      />
    </div>
  </div>

  <div
    class="ui-stepper__sub-step-columns"
    [style.grid-template-columns]="columnsTemplate"
  >
    <div
      class="ui-stepper__sub-step-column"
      *ngFor="
        let step of resolvedSteps;
        let stepIndex = index;
        trackBy: trackByStep
      "
    >
      <app-stepper-sub-step
        *ngFor="
          let subStep of step.subSteps;
          let subStepIndex = index;
          trackBy: trackBySubStep
        "
        [step]="step"
        [subStep]="subStep"
        [stepIndex]="stepIndex"
        [subStepIndex]="subStepIndex"
        [showConnector]="subStepIndex < step.subSteps.length - 1"
      />
    </div>
  </div>
</div>
